module.exports = __webpack_public_path__ + "static/media/Full-Logo.376e0261.svg";